import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M5.994 22A1.992 1.992 0 014 20v-6H2V7.998C2 6.895 2.898 6 3.99 6h2.016C5.376 5.416 5 4.734 5 4c0-1.93 1.284-3 3-3 2.52 0 4.54 1.975 4.986 4.902a8.964 8.964 0 001.706-.333l.205-.069v-.003C16.128 5.068 17 4.45 17 4c0-.737-.316-1-1-1-.608 0-1.159.168-1.617.5a7.622 7.622 0 00-.956-1.77C14.167 1.256 15.041 1 16 1c1.716 0 3 1.07 3 3 0 .733-.377 1.415-1.006 2h2.015C21.11 6 22 6.887 22 7.998V14h-9v6h5v-4h2v4c0 1.105-.895 2-1.994 2H5.994zM11 14H6v6h5v-6zm0-6.001L4 8v4l7-.001v-4zm2 4L20 12V8l-7-.001v4zM8 3c-.684 0-1 .263-1 1 0 .65 1.818 1.653 3.922 1.928C10.62 3.998 9.483 3 8 3z',
    ],
};
const IconGift = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconGift.displayName = 'IconGift';

export { IconGift };
//# sourceMappingURL=IconGift.js.map
